
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $71b057089f4a143f$exports = {};
$71b057089f4a143f$exports = " precision mediump float;\n#define GLSLIFY 1\nuniform vec3 uColor1;\nuniform vec3 uColor2;\nuniform vec3 uColor3;\nuniform float uProportion1;\nuniform float uProportion2;\nuniform float uTime;\nuniform float uMovementAmplitude;\nuniform vec2 uResolution;\nuniform float uNoiseScale;\nuniform float uMovementSpeed;\nvarying vec2 vUv;\n\n// Simplex 2D noise\nvec3 permute(vec3 x) { return mod(((x*34.0)+1.0)*x, 289.0); }\n\nfloat staticNoise(vec2 st) {\n    return fract(sin(dot(st.xy, vec2(12.9898, 78.233))) * 43758.5453123);\n}\n\nvoid main() {\n    vec2 st = vUv.yy;\n\n    st.y += sin(uTime * uMovementSpeed) * uMovementAmplitude;\n\n    vec3 color1 = uColor1;\n    vec3 color2 = uColor2;\n    vec3 color3 = uColor3;\n    \n    vec3 color;\n    if (st.y < uProportion1) {\n        color = mix(color1, color2, st.y / uProportion1);\n    } else if (st.y < uProportion1 + uProportion2) {\n        color = mix(color2, color3, (st.y - uProportion1) / uProportion2);\n    } else {\n        color = color3;\n    }\n    \n    // Static noise effect with controllable scale\n    float noiseScale = 1.;\n    float noiseIntensity = .08;\n\n    vec2 noiseCoord = floor(gl_FragCoord.xy * noiseScale) / (uResolution);\n    float noise = (staticNoise(noiseCoord) - .5) * noiseIntensity;\n    color += noise;\n    \n    gl_FragColor = vec4(color, 1.0);\n}";


var $0da8e3c342f5da54$exports = {};
$0da8e3c342f5da54$exports = "#define GLSLIFY 1\nattribute vec2 aPosition;\nvarying vec2 vUv;\nvoid main() {\n    vUv = aPosition * 0.5 + 0.5;\n    gl_Position = vec4(aPosition, 0.0, 1.0);\n}\n        ";


const $35da740d59af89ba$var$canvas = document.getElementById("canvas");
const $35da740d59af89ba$var$gl = $35da740d59af89ba$var$canvas.getContext("webgl");
function $35da740d59af89ba$var$createShader(gl, type, source) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        console.error("Shader compile error:", gl.getShaderInfoLog(shader));
        gl.deleteShader(shader);
        return null;
    }
    return shader;
}
function $35da740d59af89ba$var$createProgram(gl, vertexShader, fragmentShader) {
    const program = gl.createProgram();
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        console.error("Program link error:", gl.getProgramInfoLog(program));
        gl.deleteProgram(program);
        return null;
    }
    return program;
}
const $35da740d59af89ba$var$vShader = $35da740d59af89ba$var$createShader($35da740d59af89ba$var$gl, $35da740d59af89ba$var$gl.VERTEX_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($0da8e3c342f5da54$exports))));
const $35da740d59af89ba$var$fShader = $35da740d59af89ba$var$createShader($35da740d59af89ba$var$gl, $35da740d59af89ba$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($71b057089f4a143f$exports))));
const $35da740d59af89ba$var$program = $35da740d59af89ba$var$createProgram($35da740d59af89ba$var$gl, $35da740d59af89ba$var$vShader, $35da740d59af89ba$var$fShader);
const $35da740d59af89ba$var$positionBuffer = $35da740d59af89ba$var$gl.createBuffer();
$35da740d59af89ba$var$gl.bindBuffer($35da740d59af89ba$var$gl.ARRAY_BUFFER, $35da740d59af89ba$var$positionBuffer);
$35da740d59af89ba$var$gl.bufferData($35da740d59af89ba$var$gl.ARRAY_BUFFER, new Float32Array([
    -1,
    -1,
    1,
    -1,
    -1,
    1,
    1,
    1
]), $35da740d59af89ba$var$gl.STATIC_DRAW);
const $35da740d59af89ba$var$aPosition = $35da740d59af89ba$var$gl.getAttribLocation($35da740d59af89ba$var$program, "aPosition");
$35da740d59af89ba$var$gl.enableVertexAttribArray($35da740d59af89ba$var$aPosition);
$35da740d59af89ba$var$gl.vertexAttribPointer($35da740d59af89ba$var$aPosition, 2, $35da740d59af89ba$var$gl.FLOAT, false, 0, 0);
const $35da740d59af89ba$var$uniforms = {
    uColor1: $35da740d59af89ba$var$gl.getUniformLocation($35da740d59af89ba$var$program, "uColor1"),
    uColor2: $35da740d59af89ba$var$gl.getUniformLocation($35da740d59af89ba$var$program, "uColor2"),
    uColor3: $35da740d59af89ba$var$gl.getUniformLocation($35da740d59af89ba$var$program, "uColor3"),
    uProportion1: $35da740d59af89ba$var$gl.getUniformLocation($35da740d59af89ba$var$program, "uProportion1"),
    uProportion2: $35da740d59af89ba$var$gl.getUniformLocation($35da740d59af89ba$var$program, "uProportion2"),
    uTime: $35da740d59af89ba$var$gl.getUniformLocation($35da740d59af89ba$var$program, "uTime"),
    uMovementAmplitude: $35da740d59af89ba$var$gl.getUniformLocation($35da740d59af89ba$var$program, "uMovementAmplitude"),
    uResolution: $35da740d59af89ba$var$gl.getUniformLocation($35da740d59af89ba$var$program, "uResolution"),
    uNoiseScale: $35da740d59af89ba$var$gl.getUniformLocation($35da740d59af89ba$var$program, "uNoiseScale"),
    uMovementSpeed: $35da740d59af89ba$var$gl.getUniformLocation($35da740d59af89ba$var$program, "uMovementSpeed")
};
function $35da740d59af89ba$var$hexToRGB(hex) {
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;
    return [
        r,
        g,
        b
    ];
}
function $35da740d59af89ba$var$initUniforms() {
    const proportion1 = 33;
    const proportion2 = 52;
    const proportion3 = 0;
    const totalProportion = proportion1 + proportion2 + proportion3;
    const normalizedProportion1 = proportion1 / totalProportion;
    const normalizedProportion2 = proportion2 / totalProportion;
    const movementAmplitude = 0.03;
    const movementSpeed = 0.15;
    $35da740d59af89ba$var$gl.uniform1f($35da740d59af89ba$var$uniforms.uProportion1, normalizedProportion1);
    $35da740d59af89ba$var$gl.uniform1f($35da740d59af89ba$var$uniforms.uProportion2, normalizedProportion2);
    $35da740d59af89ba$var$gl.uniform1f($35da740d59af89ba$var$uniforms.uMovementAmplitude, movementAmplitude);
    $35da740d59af89ba$var$gl.uniform1f($35da740d59af89ba$var$uniforms.uMovementSpeed, movementSpeed);
}
/*
function updateShaderPanel() {
  const color1 = document.getElementById("color1").value;
  const color2 = document.getElementById("color2").value;
  const color3 = document.getElementById("color3").value;
  const proportion1 = parseInt(document.getElementById("proportion1").value);
  const proportion2 = parseInt(document.getElementById("proportion2").value);
  const proportion3 = parseInt(document.getElementById("proportion3").value);
  const totalProportion = proportion1 + proportion2 + proportion3;
  const normalizedProportion1 = proportion1 / totalProportion;
  const normalizedProportion2 = proportion2 / totalProportion;
  const movementAmplitude = parseFloat(
    document.getElementById("movementAmplitude").value,
  );
  const movementSpeed = parseFloat(
    document.getElementById("movementSpeed").value,
  );

  gl.uniform1f(uniforms.uProportion1, normalizedProportion1);
  gl.uniform1f(uniforms.uProportion2, normalizedProportion2);
  gl.uniform1f(uniforms.uMovementAmplitude, movementAmplitude);
  gl.uniform1f(uniforms.uMovementSpeed, movementSpeed);
  gl.uniform3fv(uniforms.uColor1, hexToRGB(color1));
  gl.uniform3fv(uniforms.uColor2, hexToRGB(color2));
  gl.uniform3fv(uniforms.uColor3, hexToRGB(color3));
}
*/ const $35da740d59af89ba$var$COLORS = [
    [
        $35da740d59af89ba$var$hexToRGB("#c7c7c7"),
        $35da740d59af89ba$var$hexToRGB("#1021E8"),
        $35da740d59af89ba$var$hexToRGB("#181818")
    ],
    [
        $35da740d59af89ba$var$hexToRGB("#c7c7c7"),
        $35da740d59af89ba$var$hexToRGB("#c7c7c7"),
        $35da740d59af89ba$var$hexToRGB("#1021E8")
    ],
    [
        $35da740d59af89ba$var$hexToRGB("#c7c7c7"),
        $35da740d59af89ba$var$hexToRGB("#c7c7c7"),
        $35da740d59af89ba$var$hexToRGB("#c7c7c7")
    ],
    [
        $35da740d59af89ba$var$hexToRGB("#1021E8"),
        $35da740d59af89ba$var$hexToRGB("#1021E8"),
        $35da740d59af89ba$var$hexToRGB("#c7c7c7")
    ],
    [
        $35da740d59af89ba$var$hexToRGB("#1021E8"),
        $35da740d59af89ba$var$hexToRGB("#1021E8"),
        $35da740d59af89ba$var$hexToRGB("#1021E8")
    ],
    [
        $35da740d59af89ba$var$hexToRGB("#181818"),
        $35da740d59af89ba$var$hexToRGB("#181818"),
        $35da740d59af89ba$var$hexToRGB("#1021E8")
    ],
    [
        $35da740d59af89ba$var$hexToRGB("#181818"),
        $35da740d59af89ba$var$hexToRGB("#181818"),
        $35da740d59af89ba$var$hexToRGB("#181818")
    ]
];
function $35da740d59af89ba$var$colorsAtIndex(i) {
    return $35da740d59af89ba$var$COLORS[i % $35da740d59af89ba$var$COLORS.length];
}
function $35da740d59af89ba$var$updateShaderColor(time) {
    const index = Math.floor(time);
    const [c11, c12, c13] = $35da740d59af89ba$var$colorsAtIndex(index);
    const [c21, c22, c23] = $35da740d59af89ba$var$colorsAtIndex(index + 1);
    const progress = time - index;
    const color1 = $35da740d59af89ba$var$mixColor(c11, c21, 1 - progress);
    const color2 = $35da740d59af89ba$var$mixColor(c12, c22, 1 - progress);
    const color3 = $35da740d59af89ba$var$mixColor(c13, c23, 1 - progress);
    $35da740d59af89ba$var$gl.uniform3fv($35da740d59af89ba$var$uniforms.uColor1, color1);
    $35da740d59af89ba$var$gl.uniform3fv($35da740d59af89ba$var$uniforms.uColor2, color2);
    $35da740d59af89ba$var$gl.uniform3fv($35da740d59af89ba$var$uniforms.uColor3, color3);
}
function $35da740d59af89ba$var$animate(time) {
    requestAnimationFrame($35da740d59af89ba$var$animate);
    $35da740d59af89ba$var$updateShaderColor(time * 0.00008);
    $35da740d59af89ba$var$gl.uniform1f($35da740d59af89ba$var$uniforms.uTime, time * 0.001);
    $35da740d59af89ba$var$gl.drawArrays($35da740d59af89ba$var$gl.TRIANGLE_STRIP, 0, 4);
}
function $35da740d59af89ba$var$resizeCanvas() {
    $35da740d59af89ba$var$canvas.width = window.innerWidth;
    $35da740d59af89ba$var$canvas.height = window.innerHeight;
    $35da740d59af89ba$var$gl.viewport(0, 0, $35da740d59af89ba$var$canvas.width, $35da740d59af89ba$var$canvas.height);
    $35da740d59af89ba$var$gl.uniform2f($35da740d59af89ba$var$uniforms.uResolution, $35da740d59af89ba$var$canvas.width, $35da740d59af89ba$var$canvas.height);
}
function $35da740d59af89ba$var$mixColor(color1, color2, proportion) {
    return color1.map((c, i)=>c * proportion + color2[i] * (1 - proportion));
}
window.addEventListener("resize", $35da740d59af89ba$var$resizeCanvas);
// [
//   "color1",
//   "color2",
//   "color3",
//   "proportion1",
//   "proportion2",
//   "proportion3",
//   "movementAmplitude",
//   "movementSpeed",
// ].forEach(id => {
//   document.getElementById(id).addEventListener("input", updateShaderPanel);
// });
$35da740d59af89ba$var$gl.useProgram($35da740d59af89ba$var$program);
$35da740d59af89ba$var$resizeCanvas();
$35da740d59af89ba$var$initUniforms();
// updateShaderPanel();
$35da740d59af89ba$var$animate(0);


//# sourceMappingURL=index.53246a19.js.map
